<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols='12'>
        <DataTable :datatable="table" :on-success="successAction" :itemsAction="successAction"/>
      </v-col>
      <v-col cols='12'>
        <ViewDetails :object="object" type="DetailEquipo" :actions="successAction" />
      </v-col>
    </v-row>
    <MainFormDialog v-if="get_dialogMain.dialog" :model="objectMain" :params="paramsMain" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { UserSession } from '@/store/modules/config'
import { Permission } from '@/mixins/permissionMain'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
import DataTable from '@/components/dataTableMain'
import ViewDetails from '@/components/ViewDetails'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'NewData', code: 'inventario.create' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Procedencia', value: 'caracteristicas.procedencia.nombre', class: 'black--text' },
          { text: 'Descripción', value: 'caracteristicas.descripcion', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Resguardante', value: 'PersonalResguardante', class: 'black--text', align: 'center' },
          { text: 'Asignado', value: 'PersonalAsignado', class: 'black--text', align: 'center' },
          { text: 'Estatus', value: 'Status', class: 'black--text', align: 'center' },
          { text: '', value: 'Actions' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateData', code: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    objectMain: {},
    paramsMain: {}
  }),
  components: {
    DataTable,
    ViewDetails,
    MainFormDialog
  },
  mounted () {
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjectsService']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.GETObjectsService({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getDataUrl('inventario.refacciones.show')
    },
    NewData (item) {
      this.objectMain = { tipo_inventario_id: 3, departamento_id: UserSession().departamento_id }
      this.paramsMain = {
        urloption: this.get_urls['inventario.options'],
        url: this.get_urls['inventario.execute'],
        process: 1,
        actividad: 3,
        message: 'Registro Agregado Correctamente',
        showFamilia: true,
        familiaParams: '?insumo=0',
        setmodel: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'create', form: 'process', with: '60%', title: 'Nuevo Refacción' })
    },
    updateData ({ item }) {
      item.caracteristicas.departamento_id = item.departamento_id
      this.objectMain = item
      this.paramsMain = {
        urloption: this.get_urls['inventario.options'],
        url: this.get_urls['inventario.execute'],
        process: 1,
        actividad: 3,
        message: 'Registro Agregado Correctamente',
        showFamilia: true,
        familiaParams: '?insumo=0',
        setmodel: true,
        updated: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'update', form: 'process', with: '60%', title: 'Editar Refacción' })
    },

    toAssign (item) {
      this.objectMain = item
      this.paramsMain = {
        urloption: this.get_urls['inventario.options'],
        url: this.get_urls['inventario.execute'],
        process: 1,
        message: 'Registro Agregado Correctamente'
      }
      this.SHOW_DIALOG_MAIN({ type: 'assign', form: 'process', with: 600, title: 'Asignar Refacción' })
    },
    toStock (item) {
      this.objectMain = item
      this.paramsMain = {
        urloption: this.get_urls['inventario.options'],
        url: this.get_urls['inventario.execute'],
        process: 1,
        message: 'Registro Agregado Correctamente'
      }
      this.SHOW_DIALOG_MAIN({ type: 'stock', form: 'process', with: 500, title: 'Resguardar Refacción' })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      this.refreshData({})
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        if (vals.length > 0) {
          this.table.modelMain = []
          this.table.modelMain.push(vals[0])
        }
        this.table.header.loading = false
      }
    }
  }
}
</script>

<style>
</style>
